import styled from 'styled-components';
import { COLORS } from '@stelecom/ui-react/assets/js/constants';
import { breakpoints } from '~/src/layout/index/styled';

export const TelephoneContainer = styled.div``;

export const TelephoneInfo = styled.p`
    font-size: 14px;
    color: ${COLORS.blueDark};
    margin-left: 10px;
    
    @media (max-width: 1440px){
        font-size: 20px;
        line-height: 28px; 
    }
`;

export const CallsBlock = styled.div`
    display: flex;
    align-items: center;
    margin-right: 86px;
  
    @media (max-width: 850px){
          margin-right: 0;
    }
`;

export const CallsLink = styled.a`
    font-size: 14px;
    line-height: 19px;
    color: ${COLORS.PINK_BRIGHT};
    border-bottom: 1px solid ${COLORS.PINK};
    width: 127px;
    transition: color .3s ease-in-out,background .3s ease-in-out,opacity .3s ease-in-out;
  
    &:hover{
        cursor: pointer;
        color: ${COLORS.PINK_BRIGHT};
        border-bottom: 1px solid ${COLORS.PINK};
    }
    
    @media (max-width: 1440px){
        margin-top: 10px;  
    }

    @media (max-width: ${breakpoints.mobile}){
        margin-left: 0;
        margin-top: 10px;
    }
`;
